import Outlets from 'components/Outlets';
import styled from 'styled-components';
import { useEffect, useState, useMemo, ChangeEvent } from 'react';
import { sortOutlets } from 'utils/common';
import usePosition from 'hooks/usePosition';
import Header from 'components/Header';
import MetaHeader from 'components/MetaHeader';
import PageContainer from 'components/PageContainer';
import { getMicrositeByOutlets } from 'services';
import PoweredByMomos from 'components/PoweredByMomos';
import { GetServerSideProps } from 'next';
import { Brand, MicrositeConfig, Outlet } from 'utils/types';
import TextInput from 'components/TextInput';
import { FILTER_LOCATION } from '../order-for-delivery/[category]';

interface LocationsProps {
  micrositeConfig: MicrositeConfig;
  brandDetails: Brand;
  data: Outlet[];
}

export default function Locations({ data, brandDetails, micrositeConfig }: LocationsProps) {
  const [locationsData, setLocationsData] = useState<Outlet[]>(data);
  const [search, setSearch] = useState<string>('');

  const { latLong }: any = usePosition();

  useEffect(() => {
    if (latLong) {
      const sortOutletsData: Outlet[] = sortOutlets(latLong, data);
      setLocationsData(sortOutletsData);
    }
  }, [data, latLong]);

  const onChangeSearch = (evt: ChangeEvent<HTMLInputElement>) => {
    setSearch(evt.target.value);
  };

  const filterLocationData: Outlet[] = useMemo(() => {
    return FILTER_LOCATION(locationsData, search);
  }, [search, locationsData]);

  return (
    <PageWrap>
      <MetaHeader
        title={`${brandDetails?.name} | Locations`}
        image={brandDetails?.logoUrl ? brandDetails.logoUrl : undefined}
        pixelId={micrositeConfig?.micrositePixelId}
      />
      <Header
        brandDetails={brandDetails}
        theme={micrositeConfig?.micrositeTheme}
        hideMenuLink={!micrositeConfig?.menuFlag}
      />
      <PageContainer>
        <h2 className="heading-1 mb-30">Locations</h2>
        <TextInput placeholder="Search by address, city or zip code" onChange={onChangeSearch} className="mb-20" />
        <Outlets data={filterLocationData} minHeight={'300px'} enableHover={false} />
        <PoweredByMomos />
      </PageContainer>
    </PageWrap>
  );
}

export const getServerSideProps: GetServerSideProps = async ({ params, req }) => {
  try {
    const data = await getMicrositeByOutlets(req, params?.slug);

    return {
      props: {
        data: data.outlets || [],
        slug: params?.slug,
        brandDetails: data?.brandDetails || null,
        micrositeConfig: data?.micrositeConfig || null,
      },
    };
  } catch (err) {
    return {
      notFound: true,
    };
  }
};

const PageWrap = styled.div`
  .options-wrap {
    margin-bottom: 20px;
    margin-top: 20px;

    .option-item {
      align-items: center;
      justify-content: center;
      display: flex;
      cursor: pointer;
      border: 1px solid var(--grey-light);
      height: 140px;
      border-radius: 10px;

      &.active-item {
        background: var(--orange);
      }

      .menu-img {
        object-fit: contain;
      }
    }
  }
`;
